import { z } from 'zod';

// ランキングデータのスキーマ
export const RankingSchema = z.object({
  score: z.number().int().positive(),
  playerName: z.string().min(1).max(20),
  userId: z.string(),
  timestamp: z.date(),
  createdAt: z.date(),
});

export type Ranking = z.infer<typeof RankingSchema>;

// キャラクタースキーマ
export const CharacterSchema = z.object({
  id: z.enum(['yukari', 'yuzuko']),
  name: z.string(),
  animatedModelPaths: z.object({
    running: z.string(),
    jumping: z.string(),
  }),
});

export type Character = z.infer<typeof CharacterSchema>;

// ゲーム設定スキーマ
export const GameConfigSchema = z.object({
  initialSpeed: z.number().positive(),
  speedIncrement: z.number().positive(),
  jumpPower: z.number().positive(),
  gravity: z.number().positive(),
  obstacleSpawnInterval: z.object({
    min: z.number().positive(),
    max: z.number().positive(),
  }),
  cameraPosition: z.object({
    x: z.number(),
    y: z.number(),
    z: z.number(),
  }),
});

export type GameConfig = z.infer<typeof GameConfigSchema>;

// 環境変数スキーマ
export const EnvSchema = z.object({
  VITE_FIREBASE_API_KEY: z.string(),
  VITE_FIREBASE_AUTH_DOMAIN: z.string(),
  VITE_FIREBASE_PROJECT_ID: z.string(),
  VITE_FIREBASE_STORAGE_BUCKET: z.string(),
  VITE_FIREBASE_MESSAGING_SENDER_ID: z.string(),
  VITE_FIREBASE_APP_ID: z.string(),
});

export type Env = z.infer<typeof EnvSchema>;

// 環境変数の検証とパース
export function validateEnv(): Env {
  const env = {
    VITE_FIREBASE_API_KEY: import.meta.env.VITE_FIREBASE_API_KEY,
    VITE_FIREBASE_AUTH_DOMAIN: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
    VITE_FIREBASE_PROJECT_ID: import.meta.env.VITE_FIREBASE_PROJECT_ID,
    VITE_FIREBASE_STORAGE_BUCKET: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
    VITE_FIREBASE_MESSAGING_SENDER_ID: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
    VITE_FIREBASE_APP_ID: import.meta.env.VITE_FIREBASE_APP_ID,
  };

  return EnvSchema.parse(env);
}

// キャラクター定義
export const CHARACTERS: Character[] = [
  {
    id: 'yukari',
    name: 'ゆかり',
    animatedModelPaths: {
      running: '/models/YukariRun.fbx',
      jumping: '/models/YukariJump.fbx',
    },
  },
  {
    id: 'yuzuko',
    name: 'ゆずこ',
    animatedModelPaths: {
      running: '/models/YuzukoRun.fbx',
      jumping: '/models/YuzukoJump.fbx',
    },
  },
];

// デフォルトゲーム設定
export const DEFAULT_GAME_CONFIG: GameConfig = {
  initialSpeed: 12, // 初期スピード
  speedIncrement: 0.16, // 速度増加率（1100点まで）
  jumpPower: 10,
  gravity: 25,
  obstacleSpawnInterval: {
    min: 800, // 出現間隔を調整（0.8秒〜1.5秒）
    max: 1500,
  },
  cameraPosition: {
    x: 0,
    y: 3,
    z: 10,
  },
};
